module.exports = __webpack_public_path__ + "img/EXE.abd313d2.png";